// constants
import { FILTER_POPPER_PORTALED_LAYER_SELECTORS } from './FilterPopper.consts';

/**
 * Whether a click outside the popper's paper still belongs to it: a click on the trigger, whose own toggle
 * would otherwise fight the close, or one in a layer a field inside the popper opened (see
 * {@link FILTER_POPPER_PORTALED_LAYER_SELECTORS}).
 */
export const isClickOnTriggerOrLayer = (
  target: EventTarget | null,
  anchor: HTMLElement | null | undefined
): boolean => {
  if (!(target instanceof Element)) return false;
  if (anchor?.contains(target)) return true;
  return target.closest(FILTER_POPPER_PORTALED_LAYER_SELECTORS) !== null;
};
